import { render, staticRenderFns } from "./PatternUserCard.vue?vue&type=template&id=743bca69&"
import script from "./PatternUserCard.vue?vue&type=script&lang=js&"
export * from "./PatternUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports